// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";

import "./TimelineDotRange.scss";

type Props = {
    item: TimelineItem,
    progress: number,
    selected: boolean
};

@observer
export default class TimelineDotRange extends React.Component<Props> {
    getDotStyle() {
        const item = this.props.item;
        if (!this.props.selected) return null;

        const progress = this.props.progress;
        let progressPercentage =
            ((progress - item.start_time) * 100) / item.duration;
        progressPercentage = Math.min(100, progressPercentage);
        progressPercentage = Math.max(0, progressPercentage);

        return {
            left: `${progressPercentage}%`
        };
    }

    render() {
        const selected = this.props.selected;

        const classes = ["TimelineDotRange"];
        if (selected) {
            classes.push("TimelineDotRange--selected");
        }

        return (
            <div className={classes.join(" ")}>
                <div
                    className="TimelineDotRange__dot"
                    style={this.getDotStyle()}
                />
                {this.renderDurationLine()}
            </div>
        );
    }

    renderDurationLine() {
        if (!this.props.selected) return null;

        return <div className="TimelineDotRange__line" />;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineDotRange/TimelineDotRange.js